// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"655fe0d5","239":"965013dc","455":"e14bf564"}[chunkId] + ".chunk.js";
};